/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import debounce from 'debounce'

import { rcmShopifyApi, TERMS_CHECKBOX, POLICIES_CHECKBOX } from 'libs/rcmShopifyApi'

import './styles.scss'

class Cart {
  constructor (element) {
    this.$el = $(element)

    this.$cartTermsCheckbox = this.$el.find('#cart_checkout_terms')
    this.$cartPoliciesCheckbox = this.$el.find('#cart_checkout_policies')
    this.$checkoutButton = this.$el.find('.button--checkout')
    this.$submitControls = this.$el.find('.cart-submitControls')
    this.$bodySpacer = $('<div class="cart-bodySpacer"></div>')
    this.$updateTotalRow = this.$el.find('.cart-updateTotalRow')
    this.hasBodySpacer = false
    this.updateTotalRowVisible = false

    this.checkTerms = this.checkTerms.bind(this)
    this.formSubmit = this.formSubmit.bind(this)
    this.debounceResize = debounce(this.onResize.bind(this), 50)
    this.debounceQtyChange = debounce(this.onQuantityChange.bind(this), 800)

    if (this.$cartTermsCheckbox.length) {
      if (rcmShopifyApi.getCartCheckbox(TERMS_CHECKBOX)) {
        this.$cartTermsCheckbox.prop('checked', true)
      }
      this.$cartTermsCheckbox.on('change', this.checkTerms)
    }
    if (this.$cartPoliciesCheckbox.length) {
      if (rcmShopifyApi.getCartCheckbox(POLICIES_CHECKBOX)) {
        this.$cartPoliciesCheckbox.prop('checked', true)
      }
      this.$cartPoliciesCheckbox.on('change', this.checkTerms)
    }
    this.checkTerms()

    this.$el.find('.quantityStepper-stepper').on('change', this.debounceQtyChange)

    this.$checkoutButton.on('click', this.formSubmit)

    this.checkCustomer()

    $(window).on('resize', this.debounceResize)
    this.debounceResize()
  }

  checkTerms () {
    let canCheckout = true
    if (this.$cartTermsCheckbox.length) {
      if (!this.$cartTermsCheckbox.is(':checked')) {
        canCheckout = false
      }
    }
    if (this.$cartPoliciesCheckbox.length) {
      if (!this.$cartPoliciesCheckbox.is(':checked')) {
        canCheckout = false
      }
    }
    this.$checkoutButton.prop('disabled', !canCheckout)
  }

  onResize () {
    if (this.$submitControls.css('position') === 'fixed') {
      if (!this.hasBodySpacer) {
        $('body').append(this.$bodySpacer)
        this.hasBodySpacer = true
      }
      this.$bodySpacer.css('height', this.$submitControls.height())
    } else {
      if (this.hasBodySpacer) {
        this.$bodySpacer.remove()
      }
    }

    if (this.$updateTotalRow.is(':visible') && !this.updateTotalRowVisible) {
      this.$el.find('.cart-row').each((index, element) => {
        const $element = $(element)
        const $stepper = $element.find('.quantityStepper')

        $element.next().find('.cart-stepperContainer').append($stepper)
        this.updateTotalRowVisible = true
      })
    } else if (!this.$updateTotalRow.is(':visible') && this.updateTotalRowVisible) {
      this.$updateTotalRow.each((index, element) => {
        const $element = $(element)
        const $stepper = $element.find('.quantityStepper')

        $element.prev().find('.cart-stepperContainer').append($stepper)
        this.updateTotalRowVisible = false
      })
    }
  }

  onQuantityChange () {
    this.$checkoutButton.prop('disabled', true)
    this.$el.find('.cart-table').css('opacity', 0.33)
    this.$el.find('input[name="update"]').trigger('click')
  }

  checkCustomer () {
    // RCM01-337
    // recharge adds its own click handler that fires first in chrome.
    // If a customer is not logged in, disable the recharge checkout. This *should* always be fine, since if there is no customer, they should always be prompted to log in.
    if (!window.customer) {
      this.$checkoutButton.attr('data-disable-recharge', 'true')
    }
  }

  formSubmit (e) {
    if (!window.customer) {
      e.preventDefault()
      if (this.$cartTermsCheckbox.is(':checked')) {
        rcmShopifyApi.setCartCheckbox(TERMS_CHECKBOX)
      }
      if (this.$cartPoliciesCheckbox.is(':checked')) {
        rcmShopifyApi.setCartCheckbox(POLICIES_CHECKBOX)
      }
      window.location = window.store.loginUrl
    } else {
      rcmShopifyApi.clearCartCheckboxes()
    }
  }
}

registerClass('Cart', Cart)
